<template>
  <div>
    <IntegrationRow
      v-for="id in feedsIds"
      :key="id"
      :feed-id="id"
      :show-delete="showDelete"
    />
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import IntegrationRow from './IntegrationRow.vue'

export default defineComponent({
  name: 'IntegrationsList',
  components: {
    IntegrationRow
  },
  props: {
    feedsIds: {
      type: Array,
      required: true
    },
    showDelete: {
      type: Boolean,
      default: false
    }
  }
})
</script>
